import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { 
	TableComponent, 
	DataReloadEvent, 
	TableColumn, 
	IdentifierTableColumn, 
	DateTableColumn, 
	CheckboxComponent, 
	NativeStateComponent, 
	TableElement 
} from '@serengeti/serengeti-common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { TaskScheduleTemplateService } from '../service/task.service';

@Component({
  selector: 'app-setting-task-schedule-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class TaskScheduleListComponent implements OnInit {

	searchName: string;

	@ViewChild('input', { static: true }) input: ElementRef;
	@ViewChild('taskList', {static: true }) taskList: TableComponent;

	currentCondition: DataReloadEvent;
	columns: TableColumn[];

	constructor(
		private router: Router,
		private taskService: TaskScheduleTemplateService,
		private translateService: TranslateService
	) {
		this.columns = [
			new IdentifierTableColumn('id', 'setting.task.schedule.list.content.column.select', false)
			.withType(CheckboxComponent)
			.withStyles('cellCenter checkbox-data'),
			new TableColumn('state', 'setting.task.schedule.list.content.column.active-state')
			.withType(NativeStateComponent)
			.withDecorator((_column: TableColumn, _element: TableElement) => {
				const state = TableColumn._getData(_element.getData(), 'state');
				if (state === 'Active') {
					_element.getData()._nativeState = 'status active';
					return 'common.active-state.options.Active';
				} else {
					_element.getData()._nativeState = 'status inactive';
					return 'common.active-state.options.Inactive';
				}
			}),
			new TableColumn('name', 'setting.task.schedule.list.content.column.name'),
			new TableColumn('apiMethod', 'setting.task.schedule.list.content.column.api-method'),
			new TableColumn('apiUrl', 'setting.task.schedule.list.content.column.api-url'),
			new DateTableColumn('createdDate', 'setting.task.schedule.list.content.column.created-date')
		];
	}

	ngAfterViewInit() {
		fromEvent(this.input.nativeElement, 'keyup')
			.pipe(
				debounceTime(150),
				distinctUntilChanged(),
				tap(() => {
					this.doRefresh();
				})
			)
			.subscribe();
	}

	ngOnInit() {
		this.doRefresh();
	}

	doRefresh() {
		this.doReload(new DataReloadEvent('createdDate', 'desc', 0, this.taskList.pageSize, this.searchName));
	}

	doReload(condition?: DataReloadEvent) {
		if (condition) {
			this.currentCondition = condition;
		} else {
			condition = this.currentCondition;
		}

		this.taskService.search(condition.filter, condition.active, condition.sortOrder, condition.pageNumber, condition.pageSize)
			.subscribe((resultPage: { totalElements: number; content: any[]; }) => {
				this.taskList.refresh(resultPage.totalElements, resultPage.content, this.columns, condition);
			});
	}

	doDelete() {
		const selectedConfigs = [];
		this.taskList.getElements().forEach(config => {
			if (config.isSelected()) {
        this.translateService.get(['setting.task.schedule.list.confirm.delete']).subscribe((messages: any) => {
          if (confirm(messages['setting.task.schedule.list.confirm.delete'])) {
            this.taskService.delete(config.getData().id).subscribe(_ => {
              this.doRefresh();
            });
          }
        });
			}
		});

	}

	goDetail($event: any) {
		const taskTemplate = $event.element.getData();

		this.router.navigate(['/main', { outlets: { content: 'setting/task/schedule/detail/' + taskTemplate.id + '/' }}]);
	}

	goManageVariables() {
		this.router.navigate([ '/main', { outlets: { content: 'setting/task/schedule/variable/list' }}]);
	}	
}
